import React from "react";
import { useLanguage } from "../../contexts/LanguageContext";
import InfoTip from "../charts/InfoTip";

// Uma secao da pagina de analytics: titulo, nota e uma grelha de graficos. Uma ressalva vai num icone de
// informacao ao lado do titulo (`info`, spec do redesign, R7); a `note` fica para o texto que se le sempre.
const Section = ({ title, note, info, className = "grid gap-4 lg:grid-cols-2", children }) => {
  const { translate } = useLanguage();
  return (
    <section className="space-y-3">
      <div>
        <div className="flex items-center gap-1">
          <h2 className="text-base font-semibold" style={{ color: "var(--color-text-primary)" }}>
            {title}
          </h2>
          {info && <InfoTip text={info} label={translate("analyticsAbout", { title })} />}
        </div>
        {note && (
          <p className="text-xs mt-1" style={{ color: "var(--color-text-secondary)" }}>
            {note}
          </p>
        )}
      </div>
      <div className={className}>{children}</div>
    </section>
  );
};

export default Section;
